(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "hoist-non-react-statics", "prop-types", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("hoist-non-react-statics"), require("prop-types"), require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.hoistNonReactStatics, global.propTypes, global.react);
    global.withClassName = mod.exports;
  }
})(this, function (_exports, _hoistNonReactStatics, _propTypes, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports["default"] = withClassName;
  _hoistNonReactStatics = _interopRequireDefault(_hoistNonReactStatics);
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

  function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

  function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

  function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

  function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

  function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

  function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

  function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

  function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

  function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function withClassName(className) {
    var hoistedMethods = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return function (Component) {
      var WithClassName =
      /*#__PURE__*/
      function (_React$Component) {
        _inherits(WithClassName, _React$Component);

        function WithClassName() {
          var _getPrototypeOf2;

          var _this;

          _classCallCheck(this, WithClassName);

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(WithClassName)).call.apply(_getPrototypeOf2, [this].concat(args)));

          _defineProperty(_assertThisInitialized(_this), "hoistMethods", function (wrappedComponent) {
            wrappedComponent && hoistedMethods.forEach(function (methodName) {
              _this[methodName] = wrappedComponent[methodName];
            });
          });

          return _this;
        }

        _createClass(WithClassName, [{
          key: "render",
          value: function render() {
            var _this$props = this.props,
                additionalClassName = _this$props.className,
                other = _objectWithoutProperties(_this$props, ["className"]);

            return _react["default"].createElement(Component, _extends({}, other, {
              className: additionalClassName ? className + ' ' + additionalClassName : className,
              ref: this.hoistMethods
            }));
          }
        }]);

        return WithClassName;
      }(_react["default"].Component);

      _defineProperty(WithClassName, "displayName", "WithClassName(".concat(Component.displayName || Component.name || 'Component', ")"));

      _defineProperty(WithClassName, "propTypes", {
        className: _propTypes["default"].string
      });

      return (0, _hoistNonReactStatics["default"])(WithClassName, Component);
    };
  }
});